import IframeWrapper from '../backoffice/iframe-wrapper';

const Financing = () => {
	return <IframeWrapper path='/shared/nuqlea-financing/seller' />;
};

export default Financing;
